import { Button } from '@finn-auto/design-system/atoms/button';
import { RefreshCw } from 'lucide-react';

/**
 * Colleague-facing fallback for a crashed People Space view.
 *
 * Unlike BookingErrorFallback (full-screen, candidate-facing) this renders
 * *inside* `<main>`, so the sidebar stays mounted and the rest of the space is
 * still navigable. That distinction is the whole point: a single view throwing
 * used to unmount the entire tree and leave a white screen with no way out but
 * a manual URL edit.
 */
export function ViewErrorFallback({ onReload }: { onReload: () => void }) {
  return (
    <div className="flex min-h-[60vh] items-center justify-center p-6">
      <div className="w-full max-w-md rounded-lg border border-gray-200 bg-white p-8 text-center">
        <h2 className="text-lg font-semibold text-gray-900">This page didn’t load</h2>
        <p className="mt-2 text-sm text-gray-600">
          Something went wrong rendering this view. The rest of People Space still works — pick
          another page from the sidebar, or reload to try again.
        </p>
        <Button className="mt-5" onClick={onReload}>
          <RefreshCw className="mr-1.5 h-4 w-4" /> Reload
        </Button>
      </div>
    </div>
  );
}
